import { render, staticRenderFns } from "./HOME_NOTIFICATIONS_SEND.vue?vue&type=template&id=7b74ba68"
import script from "./HOME_NOTIFICATIONS_SEND.vue?vue&type=script&lang=ts"
export * from "./HOME_NOTIFICATIONS_SEND.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports